histories-orders-phase-created
  span.event {this.locale().event}
  span.created
    span.phase { this.phaseName() }
  script(type="typescript").
    this.mixin('histories.base');
